import { Injectable } from '@angular/core';
import { HammerGestureConfig } from '@angular/platform-browser';

@Injectable()
export class GestureConfig extends HammerGestureConfig {
  public buildHammer(element: HTMLElement) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const mc = new (<any>window).Hammer(element);

    for (const eventName in this.overrides) {
      if (eventName) {
        mc.get(eventName).set(this.overrides[eventName]);
      }
    }

    return mc;
  }
}
